<template lang="pug">
  div(v-cloak)
    v-tabs(v-model="active" dark show-arrows slider-color="red")
      v-tab(v-for="n in tabs" :key="n.id" ripple v-if="n.show")
        span {{ n.name }}
        span(v-if="zaikoShow") ({{ zaikoShow.length }})
      v-tab-item
        v-card(flat)
          v-card-text
            div(v-if="zaikoShow")
              v-row(wrap v-for="zaiko, index in zaikoShow" :key="index")
                span {{ zaiko.auction_date | date('MM月DD日') }}
                  span(v-if="zaiko.auction_date") ({{ getDayOfWeekJapanese(zaiko.auction_date) }})
                span &nbsp;# {{zaiko.buyer_info}}
                span &nbsp;{{zaiko.supplier_name}}
                span &nbsp;{{zaiko.product}}
                span &nbsp;{{zaiko.size_name}}
                span &nbsp; {{zaiko.quantity}}本 x {{zaiko.boxes}}
            v-row.justify-center
              v-btn(@click="openDialogSearch") 引当追加
            stock-sale(:hideSearchBtn="true"
              :onContact="true"
              :dataInfo="dataInfo"
              :dialogStockSearch="dialogStockSearch"
              @closeDialogSearch="closeDialogSearch"
            )
            v-row.justify-center
              div.text-center
                v-checkbox.align-center(:input-value="action.is_order_finished" @change="updateAction({is_order_finished: $event})" label="引当完了にする")
            v-textarea(filled label="要連絡" :value="action.order_memo" @change="updateAction({order_memo: $event})" hide-details)
</template>

<script>
import StockSale from '@/app/pages/Stock/sale'
import datepick from '@/common/mixins/datepick'
import {mapGetters, mapMutations, mapActions} from 'vuex'

export default {
  data () {
    return {
      active: null,
      tabs: [
        {
          id: 1,
          prefix: 1,
          name: '引当',
          show: true
        },
        {
          id: 2,
          prefix: null,
          name: 'クレーム',
          show: false
        },
        {
          id: 3,
          prefix: 2,
          name: '関連',
          show: false
        },
        {
          id: 4,
          prefix: 3,
          name: '関連',
          show: false
        }
      ],
      dialogStockSearch: false,
      chartDetails: null,
      checkbox: false,
      zaikoShow: [],
      dataInfo: {}
    }
  },
  components: {
    StockSale
  },
  mixins: [datepick],
  computed: {
    ...mapGetters('app/ct', ['action', 'info', 'allocatedChartDetail'])
  },
  methods: {
    ...mapMutations('app/ct', ['updateAction', 'addChartDetail']),
    ...mapActions('app/ct', ['updateAction', 'addChartDetail']),
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0)
    },
    closeDialogSearch (chartDetails) {
      this.dialogStockSearch = false
      if (chartDetails && chartDetails.length) {
        let chartDetailIds = this.pluck(chartDetails, 'chart_detail_id')
        this.addChartDetail(chartDetailIds)
        this.zaikoShow = this.zaikoShow.concat(chartDetails)
      }
    },
    openDialogSearch () {
      if (this.info.id && this.info.contact_products.length) {
        this.dataInfo = {
          id: this.info.id,
          customer: this.info.customer,
          supplier: this.info.supplier
        }
        this.dialogStockSearch = true
      } else {
        this.$toastr.warning(this.$t('contact.message.missing_contact_products'))
      }
    },
    pluck (arr, prop) {
      return [...new Set(arr.map(r => r[prop]))]
    }
  },
  created () {
    if (this.allocatedChartDetail.length) {
      this.$ajax.get(`/contact/allocated_chart_details/${this.allocatedChartDetail.join(',')}`)
        .then((response) => {
          this.zaikoShow = response.data.result
        })
        .catch((messages, error) => {
          messages.map((message) => this.$toastr.error(message))
        })
    }
  }
}
</script>

<style scoped lang="stylus">
  .justify-center {
    justify-content: center;
  }
  .text-center {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/app/pages/Contact/action.vue